<template>
  <div>
    <div class="app-title">
      <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section v-menu-permission="'list'" class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>

                <em-filter ref="emListFilter" :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                           :entity="modelName"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesMstMaterialDrawingManagementResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table ref="emTable"
                        :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                        :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                        :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                        :entity="modelName"
                        :inlineActionsDisabled="prop_inline!=='1'"
                        detailInlineButtonType="showAttachmentEntity" exportDisabled withCustomRowActions
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">
                <template #left-header>
                  <b-button-group>
                    <batch-upload-attachment-with-store
                        :doQuery="doQuery"
                        :modelName="modelName"
                        :voName=$_emCustomVuexMixin_vo
                        attachmentFieldName="mmdDrawingFileIds"
                        title="上传工艺图"
                    />
                    <b-button
                        :disabled="notSelected"
                        size="sm"
                        variant="outline-primary"
                        @click="downloadEngineeringDrawing()">下载SAP工程图
                    </b-button>
                    <b-button
                        :disabled="notSelected"
                        size="sm"
                        variant="outline-primary"
                        @click="updateEngineeringDrawing()">更新SAP工程图
                    </b-button>
                    <b-button
                        :disabled="notSelected"
                        size="sm"
                        type="export"
                        variant="outline-primary"
                        @click="batchDownloadToLocal('mmdDrawingFileIds')">批量存储到本地
                    </b-button>
                  </b-button-group>
                </template>

                <template #customRowActions="{row}">
                  <b-button-group>
                    <em-button type="gotoChild"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="gotoChild(row)">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
// Author Liu Cui Cui
// Date 2023-07-19 15:09:39

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import BatchUploadAttachmentWithStore from "@/components/common/attachment/BatchUploadAttachmentWithStore";
import emCommonGotoMixin from "@/mixin/em/common/goto";

export default {
  name: "sithMesMstMaterialDrawingManagementListView",
  components: {BatchUploadAttachmentWithStore},
  mixins: [emCommonListMixin, emCommonApiMixin, commonViewsUtil, emCustomVuexMixin, emTableCheckedMixin, emCommonGotoMixin],
  data() {
    return {
      saveAttachmentLoading: false,
      attachmentIds: '',
    }
  },
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    $_customVuexName() {
      return this.customVuexName;
    },


    // 判断删除按钮是否可选
    noMaterialDrawingSelect() {
      return this.selectedMaterialDrawing.length === 0;
    }
  },
  methods: {

    getDetailInlineButtonType(row) {
      if (row.mmdDrawingFiles) {
        return 'showAttachmentEntity';
      }
      return 'showEntity';
    },

    downloadEngineeringDrawing() {

      let self = this;
      let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/downloadEngineeringDrawingManagement?ids=${this.selectIds}`

      self.$_emApiMixin_post(url, {})
          .then(response => {
            if (response.status === 200) {
              self.$message({
                message: "完成从SAP下载图纸到MOM服务器",
                type: "success",
              });

              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "失败",
                type: "error",
              });
            }
          })
          .finally(() => this.locationSelectModalVisible = false)

    },

    updateEngineeringDrawing() {

    },

    batchDownloadToLocal(paramName, fileName) {
      let attachmentIds = this.checkedRows.filter(f => this.hasCode(f[paramName])).map(o => o[paramName]).join(",");
      this.downloadAllAttachment(attachmentIds, fileName);
    },
    doQuery() {
      this.$refs["emListFilter"].doQuery();
    },

    gotoChild(row) {
      this.$_emGotoMixin_gotoHolderList("sithMesMstMaterialDrawing",
          {mmdMaterialCodeFilter: row.mmdMaterialCode},
          {mmdMaterialCode: row.mmdMaterialCode},
          false,
          {})
    },

  },
  mounted() {
    this.doQuery()
  }
};
</script>